import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { parseDealsBanner } from './parseDealsBanner';

interface IUseContentParams {
  canParse: boolean;
  postContent: string;
  setPostContent: Dispatch<SetStateAction<string>>;
  done(): void;
  options?: { isEnabled: boolean };
}

/**
 * Вырезает из контента статьи маркер `<div data-name="deal-experiment-banner"></div>`
 * и заменяет его на пустой контейнер с id — сам DealsBanner в этот контейнер
 * монтируется отдельно (через React portal), т.к. зависит от группы
 * эксперимента и не должен рендериться из этого хука
 */
export const useContentDealsBannerNew = ({
  canParse,
  postContent,
  setPostContent,
  done,
  options,
}: IUseContentParams) => {
  const { pathname } = useLocation();
  const [prevPathname, setPrevPathname] = useState(pathname);
  const [isParsed, setIsParsed] = useState(false);
  const [dealsBannerContainerId, setDealsBannerContainerId] = useState<string | null>(null);

  /** Сбрасывает стэйт при клиентском переходе с поста на пост */
  useEffect(() => {
    if (pathname !== prevPathname) {
      setPrevPathname(pathname);
      setIsParsed(false);
      setDealsBannerContainerId(null);
    }
  }, [pathname, prevPathname]);

  /** Парсит маркер баннера */
  useEffect(() => {
    if (!canParse || isParsed) {
      return;
    }

    if (options?.isEnabled !== false) {
      const { items, html } = parseDealsBanner(postContent);

      if (items.length) {
        setPostContent(html);
        setDealsBannerContainerId(items[0].id);
      }
    }

    setIsParsed(true);
    done();
  }, [canParse, done, isParsed, options?.isEnabled, postContent, setPostContent]);

  return dealsBannerContainerId;
};
